import React from 'react';
import { Calendar } from 'lucide-react';
import MonthNavigation from './MonthNavigation';
import EventCard from './EventCard';

/**
 * Timeline component for showing events
 * @param {Object} props - Component props
 * @param {Array} props.events - All events
 * @param {Array} props.filteredEvents - Events filtered by current month/year
 * @param {Object} props.selectedEvent - Currently selected event
 * @param {Function} props.onSelectEvent - Event selection handler
 * @param {number} props.currentMonth - Current month (0-11)
 * @param {number} props.currentYear - Current year
 * @param {Function} props.onPreviousMonth - Previous month handler
 * @param {Function} props.onNextMonth - Next month handler
 */
const Timeline = ({ 
  events, 
  filteredEvents, 
  selectedEvent, 
  onSelectEvent,
  currentMonth,
  currentYear,
  onPreviousMonth,
  onNextMonth
}) => {
  return (
    <div className="w-full h-full flex flex-col border-r border-gray-200">
      <MonthNavigation 
        currentMonth={currentMonth}
        currentYear={currentYear}
        onPreviousMonth={onPreviousMonth}
        onNextMonth={onNextMonth}
      />
      
      <div className="flex-1 overflow-y-auto p-3 bg-white">
        {filteredEvents.length > 0 ? (
          <div className="space-y-3">
            {filteredEvents.map((event) => (
              <EventCard 
                key={event.id} 
                event={event} 
                isSelected={selectedEvent?.id === event.id}
                onSelect={onSelectEvent}
              />
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center h-full text-gray-500">
            <Calendar size={36} className="mb-3 opacity-50" />
            <p className="text-sm">No events scheduled for this month</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Timeline;